
export const StringValidation = {
    /* This file contains custom validation utility functions to validate string values alone 
sample scenarios are below
 isNullOrEmpty("")         // true
 isNullOrEmpty("  ")       // true
 isNullOrEmpty(null)       // true
 isNullOrEmpty(undefined)  // true
 isNullOrEmpty("valid")    // false
*/
    isNullOrEmpty(value?: string | null): boolean {
        return !value || value.trim() === "";
    }
};
